// Added comments to trigger github actions.
import { actions } from "utils/helpers";
import Table from "components/Table/Table";
import { Fragment, useCallback, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectAuthUser } from "features/auth/authSlice";
import Pagination from "components/Pagination/Pagination";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import TableSkeleton from "components/Table/TableSkeleton/TableSkeleton";
import { toast } from "react-hot-toast";
import { UNAUTHORIZED } from "constants";
import {
  useDeleteAudioFileMutation,
  useGetAudioFilesQuery
} from "features/audioFiles/audioFilesApiSlice";

import styles from "pages/Accounts/Accounts.module.scss";
import cardStyles from "styles/modules/Card.module.scss";

const AudioFiles = ({ label }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const {
    currentData,
    isFetching: isLoading,
    isError,
    error
  } = useGetAudioFilesQuery(searchParams.toString());

  const [deleteAudio] = useDeleteAudioFileMutation();

  const authUser = useSelector(selectAuthUser);

  useEffect(() => {
    dispatch(setNavbarTitle("Accounts"));
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      toast.error(error || "Could not load audio files, try refreshing the page");
    }
  }, [isError, error]);

  const onItemClickHandler = (id) => {
    navigate(`/audio_files/${id}`);
  };

  // const onEditHandler = useCallback(
  //   (id, callFn = false) => {
  //     if (authUser?.actions[label].includes(actions.view)) {
  //       if (callFn) {
  //         navigate(`/accounts/${id}`);
  //       }

  //       return "";
  //     }

  //     return UNAUTHORIZED;
  //   },
  //   [authUser?.actions, label, navigate]
  // );

  const onDeleteHandler = useCallback(
    async (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.delete)) {
        if (callFn) {
          await deleteAudio(id).unwrap();
        }

        return "";
      }

      return UNAUTHORIZED;
    },
    [authUser?.actions, deleteAudio, label]
  );

  return (
    <div className={styles.container}>
      <div className={cardStyles.menu}>
        <h3>Showing data for audio files</h3>
      </div>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Fragment>
          <Table
            data={currentData}
            onDelete={onDeleteHandler}
            onItemClickHandler={onItemClickHandler}
          />
          <Pagination totalCount={currentData?.size} />
        </Fragment>
      )}
    </div>
  );
};

export default AudioFiles;
